import VueCookies from 'vue-cookies'

import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export default {
  install (Vue, options) {
    const $tools = {

      isMobile () {
        return window.innerWidth <= 960
      },

      isTouchDevice () {
        return (('ontouchstart' in window) ||
             ('ontouchstart' in document.documentElement) ||
             (navigator.MaxTouchPoints > 0) ||
             (navigator.msMaxTouchPoints > 0))
      },

      webglSupport(){ 
        try {
          var canvas = document.createElement('canvas'); 
          return !!window.WebGLRenderingContext &&
            (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')) ? true : false;
        } catch(e) {
          return false;
        }
      },

      cookiesTest()
      {
        if(JSON.parse(VueCookies.get('cookies')) && JSON.parse(VueCookies.get('cookies')).find( cookie => cookie.name === 'ga').state)
          return true
        else
          return false
      },

      async cameraSupport()
      {
        if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
          return false
        }else{
          let constraints={audio:false,video:true};
          return await navigator.mediaDevices.getUserMedia(constraints)
              .then((stream)=>{ return true })
              .catch((err)=>
              {
                if(err.name=="NotAllowedError"){
                  console.log("User has denied accessed")
                }

                return false
              });
          
        }
      },

      expSupport()
      {
        let test = this.webglSupport() && this.cameraSupport()
        return test
      },

      disableScroll()
      {
        // disableBodyScroll(document.body)
        // if (window.addEventListener) // older FF
        //   window.addEventListener('DOMMouseScroll', this.preventDefault, false);

        // document.body.style.overflowY = "hidden"
        // document.querySelector('html').style.overflowX = 'inherit'
        let top = window.scrollY || document.documentElement.scrollTop
        console.log(top)
        document.body.style.top =  - top + 'px';
        document.body.style.position = 'fixed';

        // document.addEventListener('wheel', this.preventDefault, {passive: false}); // Disable scrolling in Chrome
        // // window.onwheel = this.preventDefault; // modern standard
        // // window.onmousewheel = document.onmousewheel = this.preventDefault; // older browsers, IE
        // window.ontouchmove  = this.preventDefault; // mobile
        // document.onkeydown  = this.preventDefaultForScrollKeys;
      },
      preventDefault(e) {
        window.scrollTop = 0
        e = e || window.event;
        if (e.preventDefault)
            e.preventDefault();
        e.returnValue = false;  
      },
      preventDefaultForScrollKeys(e) {
        var keys = {37: 1, 38: 1, 39: 1, 40: 1}

        if (keys[e.keyCode]) {
          this.preventDefault(e);
          return false;
        }
      },
      enableScroll() {
        // enableBodyScroll(document.body)
        // if (window.removeEventListener)
        //   window.removeEventListener('DOMMouseScroll', this.preventDefault, false);
        // document.removeEventListener('wheel', this.preventDefault, {passive: false}); // Enable scrolling in Chrome
        // document.body.style.overflowY = 'inherit'
        // document.querySelector('html').style.overflowX = 'hidden'
        const top = document.body.style.top;
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo(0, parseInt(top || '0') * -1);
        // window.onmousewheel = document.onmousewheel = null; 
        // window.onwheel = null; 
        // window.ontouchmove = null;  
        // document.onkeydown = null;  
      },
      path()
      {
        console.log('path', process.env.VUE_APP_ENV, process.env.VUE_APP_ENV === 'production' || process.env.VUE_APP_ENV === 'staging' ? '/qualiscore' : '')
        return process.env.VUE_APP_ENV === 'production' || process.env.VUE_APP_ENV === 'staging' ? '/jevalue-mon-logement' : ''
      }
    }

    Vue.prototype.$tools = $tools
    Vue.$tools = $tools
  }
}
